import React, { useState, useEffect } from "react";
import { Phone, MapPin, Instagram, Facebook, Globe, MessageCircle, Menu } from "lucide-react";
import Chatbot from "./components/Chatbot";
import Nosotros from "./components/Nosotros";
import Catalogo from "./components/Catalogo";
import Servicios from "./components/Servicios";


// ⛔ VERSION PARA EVITAR CACHÉ EN HOSTINGER
const VERSION = "1.0.1";

// Define LOGO
const LOGO = `/images/logo.png?v=${VERSION}`;

// Define las ubicaciones
const LOCATIONS = [
  {
    name: "Medicentro La Esperanza (Edificios Morados)",
    address: "25 AV. NTE y 25c. Pte, San Salvador",
    phones: ["7170-7292", "2225-8623", "2235-7080"],
    whatsapp: "7170-7292",
    map: "https://www.google.com/maps?q=Medicentro+La+Esperanza,+San+Salvador",
    image: `/images/medicentro.jpg?v=${VERSION}`
  },
  {
    name: "Humana Centro Médico Integral, San Benito",
    address: "Nivel 19, Consultorio 1908, Avenida La Capilla 101, San Salvador",
    phones: ["7996-9004", "2237-1568"],
    whatsapp: "7996-9004",
    map: "https://www.google.com/maps?q=Humana+Centro+Medico+Integral,+San+Salvador",
    image: `/images/humana.jpg?v=${VERSION}`
  }
];

// Define textos de las secciones
const TEXT = {
  es: {
    topBar: "Dr. Álvaro Alfonso",
    heroTitle: "Cuidado profesional para tu visión",
    heroSub: "Más de 25 años de experiencia y tecnología de vanguardia.",
    serviciosTitle: "Servicios",
    nosotrosTitle: "Nosotros",
    equiposTitle: "Tecnología & Equipos",
    ubicacionesTitle: "Ubicaciones",
    horariosTitle: "Horarios",
    agendarTitle: "Agendar Cita",
    whatsappLabel: "WhatsApp",
    mapLabel: "Ver en Google Maps",
    bookHere: "Agendar aquí",
    footerAboutTitle: "Dr. Álvaro Alfonso",
    footerAboutText: "Cuidado profesional para tu visión con más de 25 años de experiencia.",
    quickLinks: "Enlaces Rápidos",
    quickServicios: "Servicios",
    quickNosotros: "Nosotros",
    copyright: "© 2025 Dr. Álvaro Alfonso. Todos los derechos reservados.",
  },
  en: {
    topBar: "Ophthalmology s",
    heroTitle: "Professional care for your vision",
    heroSub: "Over 15 years of experience with cutting-edge technology.",
    serviciosTitle: "Services",
    nosotrosTitle: "About Us",
    equiposTitle: "Technology & Equipment",
    ubicacionesTitle: "Locations",
    horariosTitle: "Schedule",
    agendarTitle: "Book Appointment",
    whatsappLabel: "WhatsApp",
    mapLabel: "Open in Google Maps",
    bookHere: "Book here",
    footerAboutTitle: "Ophthalmology s",
    footerAboutText: "Professional care for your vision with over 15 years of experience.",
    quickLinks: "Quick Links",
    quickServicios: "Services",
    quickNosotros: "About Us",
    copyright: "© 2025 Ophthalmology s. All rights reserved.",
  }
};

// ⚡️ LISTA DE EQUIPOS (AGREGADO SIN TOCAR TU ESTRUCTURA)
const EQUIPOS = [
  {
    nombre: "Topógrafo corneal",
    imagen: "/equipos/topografo.jpg",
    descripcion: "Estudia la superficie corneal con precisión avanzada."
  },
  {
    nombre: "Autorefractómetro digital",
    imagen: "/equipos/autorefractometro.jpg",
    descripcion: "Determina la graduación visual de manera rápida y exacta."
  },
  {
    nombre: "Lámpara de hendidura",
    imagen: "/equipos/lampara.jpg",
    descripcion: "Permite evaluar estructuras oculares en alta resolución."
  },
  {
    nombre: "OCT de retina",
    imagen: "/equipos/oct.jpg",
    descripcion: "Explora la retina en profundidad mediante tomografía óptica."
  },
  {
    nombre: "Lensómetro profesional",
    imagen: "/equipos/lensometro.jpg",
    descripcion: "Mide con exactitud la graduación de lentes."
  },
  {
    nombre: "Campímetro visual",
    imagen: "/equipos/campimetro.jpg",
    descripcion: "Analiza el campo visual del paciente."
  }
];

export default function App() {
  const [lang, setLang] = useState("es");
  const t = TEXT[lang];

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = 3;

  const nextSlide = () => setCurrentSlide(prev => (prev + 1) % totalSlides);
  const prevSlide = () => setCurrentSlide(prev => (prev - 1 + totalSlides) % totalSlides);

  const toggleMenu = () => setIsMenuOpen(prev => !prev);

  useEffect(() => {
    console.log("LOCATIONS:", LOCATIONS);
  }, []);

  return (
    <div className="min-h-screen bg-white text-gray-900">

      {/* Top Bar */}
      <div className="w-full bg-[#0A1A2F] text-white py-2 px-4 flex justify-between items-center text-sm sm:text-base">
        <span className="flex items-center gap-3">
          <img src={LOGO} alt="logo" className="w-6 h-6 object-contain" />
          {t.topBar}
        </span>
        <div className="flex items-center gap-4">
          <a href="https://www.facebook.com/share/17V1gjqtFt/?mibextid=wwXIfr" target="_blank" rel="noreferrer"><Facebook size={18} /></a>
          <a href="https://www.instagram.com/dr.alvaroalfonso.sv/" target="_blank" rel="noreferrer"><Instagram size={18} /></a>
          <button onClick={() => setLang(lang === "es" ? "en" : "es")} className="flex items-center gap-1 hover:text-blue-300">
            <Globe size={16} /> {lang === "es" ? "EN" : "ES"}
          </button>
        </div>
      </div>

   {/* Header */}
<header className="sticky top-0 z-50 bg-white/90 backdrop-blur shadow-sm">
  <div className="max-w-6xl mx-auto px-6 py-3 flex items-center justify-between relative">

    {/* Logo */}
    <div className="flex items-center gap-3">
      <img src={LOGO} alt="logo" className="w-10 h-10 object-contain" />
      <div className="font-semibold">{t.footerAboutTitle}</div>
    </div>

    {/* Botón menú móvil */}
    <button
      className="sm:hidden flex items-center justify-center z-50"
      onClick={toggleMenu}
    >
      <Menu size={26} />
    </button>

    {/* Menú escritorio (NO se toca) */}
    <nav className="hidden sm:flex gap-6 text-sm sm:text-base">
      <a href="#inicio" className="hover:text-blue-600">Inicio</a>
      <a href="#servicios" className="hover:text-blue-600">Servicios</a>
      <a href="#nosotros" className="hover:text-blue-600">Nosotros</a>
      <a href="#catalogo" className="hover:text-blue-600">Catálogo</a>
      <a href="#ubicaciones" className="hover:text-blue-600">Ubicaciones</a>
      <a href="#agendar" className="hover:text-blue-600">Agendar</a>
    </nav>

    {/* ✅ MENÚ MÓVIL BIEN POSICIONADO BAJO EL HEADER */}
    <div
      className={`sm:hidden absolute top-full left-0 w-full bg-white shadow-lg transition-all duration-300
      ${isMenuOpen ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-4 pointer-events-none"}`}
    >
      <nav className="flex flex-col divide-y text-center">
        <a onClick={toggleMenu} href="#inicio" className="py-4 hover:bg-gray-100">Inicio</a>
        <a onClick={toggleMenu} href="#servicios" className="py-4 hover:bg-gray-100">Servicios</a>
        <a onClick={toggleMenu} href="#nosotros" className="py-4 hover:bg-gray-100">Nosotros</a>
        <a onClick={toggleMenu} href="#catalogo" className="py-4 hover:bg-gray-100">Catálogo</a>
        <a onClick={toggleMenu} href="#ubicaciones" className="py-4 hover:bg-gray-100">Ubicaciones</a>
        <a onClick={toggleMenu} href="#agendar" className="py-4 hover:bg-gray-100">Agendar</a>
      </nav>
    </div>

  </div>
</header>



      {/* Hero */}
      <section id="inicio" className="relative w-full h-[80vh] sm:h-[90vh] md:h-[100vh] overflow-hidden">
        <div className="absolute inset-0 flex transition-transform duration-700" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
          {['/images/hero.jpg', '/images/hero2.jpg', '/images/hero3.jpg'].map((img, i) => (
            <div key={i} className="min-w-full h-full relative">
              <img src={`${img}?v=${VERSION}`} alt={`slide-${i}`} className="w-full h-full object-cover" />
              <div className="absolute inset-0 bg-black/40"></div>
              <div className="relative h-full flex flex-col justify-center items-center text-center text-white px-6">
                <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold drop-shadow-lg">{t.heroTitle}</h1>
                <p className="mt-4 text-lg sm:text-xl max-w-2xl drop-shadow">{t.heroSub}</p>
              </div>
            </div>
          ))}
        </div>
        <button onClick={prevSlide} className="absolute left-4 top-1/2 -translate-y-1/2 bg-black/40 text-white p-3 rounded-full">‹</button>
        <button onClick={nextSlide} className="absolute right-4 top-1/2 -translate-y-1/2 bg-black/40 text-white p-3 rounded-full">›</button>
      </section>

      {/* Servicios */}
      <Servicios titulo={t.serviciosTitle} />

      {/* Nosotros */}
      <Nosotros />

      {/* Catálogo */}
      <Catalogo />

      {/* Equipos */}
      <section id="equipos" className="py-20 bg-gray-50 border-t">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center text-blue-900">{t.equiposTitle}</h2>
        <p className="text-center text-gray-700 mt-2">{t.equiposSub}</p>

        <div className="max-w-6xl mx-auto grid sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 px-6 mt-12">

          {/* ⚡️ AQUÍ SE INSERTA LA LISTA REAL DE EQUIPOS */}
          {EQUIPOS.map((eq, i) => (
            <article key={i} className="bg-white border rounded-2xl shadow-md overflow-hidden cursor-pointer transform transition-all duration-500 hover:-translate-y-2 hover:shadow-xl">
              <div className="h-48 bg-gray-200 overflow-hidden">
                <img
                  src={`${eq.imagen}?v=${VERSION}`}
                  alt={eq.nombre}
                  className="w-full h-full object-cover transition-transform duration-700 hover:scale-110"
                />
              </div>

              <div className="p-5">
                <h4 className="text-xl font-semibold text-blue-900">{eq.nombre}</h4>
                <p className="text-gray-600 text-sm mt-2">{eq.descripcion}</p>
              </div>
            </article>
          ))}

        </div>
      </section>

      {/* Ubicaciones */}
      <section id="ubicaciones" className="py-16 bg-white border-t">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center text-blue-900 mb-8">{t.ubicacionesTitle}</h2>
        <div className="max-w-6xl mx-auto grid sm:grid-cols-1 md:grid-cols-2 gap-6 px-6">
          {LOCATIONS.map((loc, i) => (
            <div key={i} className="bg-white rounded-2xl border shadow-sm overflow-hidden">
              <img src={loc.image} alt={loc.name} className="w-full h-44 object-cover"/>
              <div className="p-6">
                <h3 className="text-xl font-semibold text-blue-900">{loc.name}</h3>
                <p className="text-sm text-gray-700 mt-1">{loc.address}</p>
                <a href={loc.map} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 text-blue-700 mt-2 hover:underline">
                  <MapPin size={16}/> {t.mapLabel}
                </a>
                <div className="mt-3 space-y-1">
                  {loc.phones && loc.phones.map((p, idx) => (
                    <p key={idx} className="flex items-center gap-2 text-gray-800">
                      <Phone size={15} className="text-blue-700"/> {p}
                    </p>
                  ))}
                </div>
                <div className="mt-4">
                  <a href={`https://wa.me/503${loc.whatsapp.replace(/[^0-9]/g,'')}`} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-green-600 text-white">
                    <MessageCircle size={16}/> {t.whatsappLabel} {loc.whatsapp}
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Horarios */}
      <section id="horarios" className="py-16 bg-gray-50">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center text-blue-900">{t.horariosTitle}</h2>
        <ul className="mt-4 text-center text-gray-700 space-y-1">
          {["Lunes a Viernes: 7:00 AM - 3:00 PM", "Sábados: 7:00 AM - 11:00 PM", "Domingos: Cerrado"].map((h, i) => (
            <li key={i}>{h}</li>
          ))}
        </ul>
      </section>

      {/* Agendar */}
      <section id="agendar" className="py-16 bg-white border-t">
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-center text-blue-900 mb-6">{t.agendarTitle}</h2>
        <div className="max-w-4xl mx-auto grid sm:grid-cols-1 md:grid-cols-2 gap-4 px-6">
          {LOCATIONS.map((loc, i) => (
            <a key={i} href={`https://wa.me/503${loc.whatsapp.replace(/[^0-9]/g,'')}`} target="_blank" rel="noreferrer" className="flex items-center justify-center gap-2 px-6 py-4 rounded-xl bg-green-600 text-white shadow hover:opacity-95">
              <MessageCircle size={18}/> {t.bookHere}: {loc.name.split('(')[0].trim()}
            </a>
          ))}
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#0A1A2F] text-white py-12 mt-8">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-3 gap-8">
          <div>
            <h4 className="font-semibold">{t.footerAboutTitle}</h4>
            <p className="text-sm text-gray-300 mt-2">{t.footerAboutText}</p>
          </div>
          <div>
            <h4 className="font-semibold">{t.quickLinks}</h4>
            <ul className="mt-2 space-y-1 text-sm">
              <li><a href="#servicios" className="hover:underline">{t.quickServicios}</a></li>
              <li><a href="#nosotros" className="hover:underline">{t.quickNosotros}</a></li>
            </ul>
          </div>
          <div className="text-sm text-gray-300">
            <p>{t.copyright}</p>
          </div>
        </div>
      </footer>

      <Chatbot />
    </div>
  );
}